import React from 'react';
import { FiChevronRight } from 'react-icons/fi';
import { AirflowTaskDefinition } from '../types';
import styles from '../styles.module.scss';

type TaskHeaderProps = {
    dagId: string;
    taskId: string;
    task: AirflowTaskDefinition | null;
    isLoading: boolean;
    onDagClick: () => void;
    onRunsClick: () => void;
};

/*
 * DAG-task detail header: breadcrumb, title, and operator/trigger-rule meta fields
 */
export function TaskHeader({ dagId, taskId, task, isLoading, onDagClick, onRunsClick }: TaskHeaderProps) {
    return (
        <div>
            <div className={styles.breadcrumb}>
                <span className={styles.breadcrumbLink} onClick={onDagClick}>
                    {dagId}
                </span>
                <FiChevronRight />
                <span className={styles.breadcrumbLink} onClick={onRunsClick}>
                    All Runs
                </span>
                <FiChevronRight />
                <span style={{ fontFamily: 'monospace' }}>{taskId}</span>
            </div>
            <div className={styles.headerRow}>
                <h1>{isLoading || !task ? taskId : task.task_display_name ?? taskId}</h1>
            </div>
            {!isLoading && task && (
                <div className={styles.metaGrid}>
                    <div className={styles.metaField}>
                        <div className={styles.metaLabel}>Operator</div>
                        <div className={styles.metaValue}>{task.operator_name ?? task.class_ref?.class_name ?? '—'}</div>
                    </div>
                    <div className={styles.metaField}>
                        <div className={styles.metaLabel}>Trigger Rule</div>
                        <div className={styles.metaValue}>{(task.trigger_rule ?? '—').replace(/_/g, ' ')}</div>
                    </div>
                </div>
            )}
        </div>
    );
}
